import { Suspense, lazy } from "react";
import { useSprint26FlagVisible } from "../lib/featureFlags.js";

/**
 * E-BUNDLE-14 — Ladeschranke vor dem Feedback-Widget. Siehe
 * `search/GlobalSearchPaletteGate.tsx` fuer die Begruendung: das Flag
 * `sprint26.feedbackWidget` ist `internal_admin_only` und Default OFF. Das
 * Widget zog ausserdem die Preference-Registry und mehrere
 * Design-System-Bausteine in den Startpfad, zusammen rund 2,6 kB generierten
 * Code, ohne dort je etwas zeichnen zu koennen.
 */
const FeedbackWidget = lazy(async () => {
  const mod = await import("./FeedbackWidget.js");
  return { default: mod.FeedbackWidget };
});

export function FeedbackWidgetGate() {
  const { visible } = useSprint26FlagVisible("sprint26.feedbackWidget");
  if (!visible) return null;
  return (
    <Suspense fallback={null}>
      <FeedbackWidget />
    </Suspense>
  );
}
